/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsHeartFill: {
  name: 'heart-fill';
  data: string;
} = {
  name: 'heart-fill',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M4.5 1.5c-1.13 0-2.144.427-2.87 1.226C.906 3.522.5 4.65.5 6c0 2.224 1.391 3.942 2.923 5.265.773.667 1.605 1.254 2.357 1.77l.387.264c.6.41 1.12.764 1.516 1.088a.5.5 0 0 0 .634 0c.395-.324.915-.678 1.516-1.088l.387-.264c.752-.516 1.584-1.103 2.357-1.77C14.109 9.942 15.5 8.224 15.5 6c0-1.35-.406-2.478-1.13-3.274-.726-.799-1.74-1.226-2.87-1.226-1.088 0-1.936.273-2.59.709-.371.248-.67.541-.91.852a3.837 3.837 0 0 0-.91-.852C6.436 1.773 5.587 1.5 4.5 1.5Z" fill="currentColor"/></svg>`,
};
